
import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MdPaginator, MdSnackBar, MdDialog } from "@angular/material";
import { DataSource } from "@angular/cdk/collections";
import { IncassoListItemModel } from "../../models/incassi/incasso-list-item.model";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { BrogliacciService } from './../../services/brogliacci.service';
import { IncassiService } from "../../services/incassi.service";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { BrogliaccioDistintaModel } from "../../models/brogliacci/brogliaccio-distinta.model";
import { IncassoContantiListItemModel } from "../../models/incassi/incasso-contanti-list-item.model";
import { IncassoAssegniListItemModel } from "../../models/incassi/incasso-assegni-list-item.model";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { DistintaContantiDialogConfigModel, DistintaContantiDialog } from "../incassi/distinta-contanti.component";
import { DistintaAssegniDialogConfigModel, DistintaAssegniDialog } from "../incassi/distinta-assegni.component";
import { DistinteIncassiService } from "../../services/distinte-incassi.service";
import { Configurations } from "../../core/configurations";
import { DistintaModel } from '../../models/brogliacci/distinta-model';
import { IncassoDistintaModel } from '../../models/brogliacci/incasso-distinta-model';
import { DistintaIncassoComponent, DistintaIncassoComponentConfig } from '../incassi/distinta-incasso-component';
import { PartitaListItemModel } from '../../models/incassi/partita-list-item.model';
import { IncassoModel } from '../../models/incassi/incasso.model';
import { AccontoModel } from '../../models/incassi/acconto.model';


@Component({
  selector: 'app-distinta-incassi-detail',
  templateUrl: './distinta-incassi-detail.component.html',
  styleUrls: ['./distinta-incassi-detail.component.css']
})

export class DistintaIncassiDetailComponent implements OnInit {
  activatedRoute: any;
  //nuovo Distinta
  distintaCorrente: DistintaModel;
  incassiDetail:IncassoDistintaModel[];
  //brogliacci della distinta
  brogliacci: BrogliaccioDistintaModel[];
  accontiDataSource: AccontiDataSource = null;
  hasAssegni:boolean=false;
  hasContanti:boolean=false;
  hasAcconti:boolean=false;
  displayedColumns = [ 'numeroDocumento','dataDocumento', 'dataScadenza', 'totaleFattura',
   'importoResiduo', 'importoAssegnato','idIncasso','ragioneSocialeCliente'];
  partiteAssegnateDatasource: PartiteDataSource = null;
  displayedColumnsAcconto = ['codiceAs400', 'nomeAzienda', 'partitaIVA', 'importo','idIncasso'];
  isLoading:boolean;
  incassoDetailDlg:MdDialog;
  constructor(
    private configuration: Configurations,
    private _brogliacciService: BrogliacciService,
    private _distintaService: DistinteIncassiService,
    private snackBar: MdSnackBar,
    private route: ActivatedRoute,
    private distintaIncassoDialog: MdDialog,
    private router: Router,
    private distintaContantiDlg: MdDialog,
    private distintaAssegniDlg: MdDialog,) { }


  ngOnInit() {
    this.isLoading=true;
    this.brogliacci = [];
    let main =this;
    //carica dettaglio distinta incassi
    this.route.paramMap
      .switchMap((params: ParamMap) => this._distintaService.get(params.get('gid')))
      .finally(() => this.isLoading = false )
      .subscribe(
      d => {

        this.distintaCorrente = d;
        let partiteDistinta:PartitaListItemModel[]=[];
        d.incassiDistinta.map(function(inc){
          partiteDistinta=partiteDistinta.concat( inc.incasso.partiteIncassoViewModel);
        });
        if (d.incassiDistinta != null && d.incassiDistinta.length > 0) {
          let acconti: AccontoModel[] = [];
          d.incassiDistinta.map(function (inc) {
            if (inc.incasso.accontiIncasso != null && inc.incasso.accontiIncasso.length > 0) {
              acconti = acconti.concat(inc.incasso.accontiIncasso);
              main.hasAcconti = true;
            }
            if (inc.incasso.totaleValuta && inc.incasso.totaleValuta > 0) {
              main.hasContanti = true;
            }
            if (inc.incasso.totaleAssegni && inc.incasso.totaleAssegni > 0) {
              main.hasAssegni = true;
            }

          }

          );
          main.accontiDataSource = new AccontiDataSource(acconti);
        }
        this.partiteAssegnateDatasource=new PartiteDataSource(partiteDistinta);
        if(d.incassiDistinta&&d.incassiDistinta.length>0) {
          this.incassiDetail=d.incassiDistinta;
        }
        //dettaglio brogliacci appartenenti alla distinta
        this._brogliacciService.getBrogliacciDistintaList(d.token)
          .finally(() => this.isLoading = false )
          .subscribe(b => b.forEach(bb => {
            this.brogliacci.push(bb);
          }));
      },
      error => {
        this.showError("Errore durante il caricamento delle informazioni");

      }
      );
  }

  /* TOTALI degli incassi dei brogliacci della distinta */
  totaleMonete(listaContanti: IncassoContantiListItemModel[]): number {
    let tot = 0;
    if (!listaContanti) { return 0; }
    listaContanti.forEach(c => {
      if (c.idTaglio === 8 && c.importo != null) {
        tot = tot + c.importo;
      }
    });
    return tot;

  }
  info_cliente(incasso) {
    let incassoDistinta = this.incassiDetail.filter(id=>id.incasso.tokenIncasso===incasso.tokenIncasso);
    let dlgConf=new DistintaIncassoComponentConfig(incassoDistinta[0],false);
    
    this.distintaIncassoDialog.open(DistintaIncassoComponent,{data:dlgConf});
  }
  totaleBanconote(listaContanti: IncassoContantiListItemModel[]): number {
    let tot = 0;
    if (!listaContanti) { return 0; }
    listaContanti.forEach(c => {
      if (c.idTaglio !== 8 && c.importo != null) {
        tot = tot + c.importo;
      }
    });
    return tot;
  }

  /* CONFERMA */
  confermaDistinta(): void {

    if (this.distintaCorrente.stato.id !== 1) {
      this.showError("Errore. La distinta non può essere confermata");
    } else {
      this.isLoading=true;
      this._distintaService.confermaDistintaIncassi(this.distintaCorrente)
      .finally(()=>this.isLoading=false)
        .subscribe(
          data => {
            this.distintaCorrente.stato = new DizionarioModel();
            this.distintaCorrente.stato.id = 2;
            this.showInfo("Conferma avvenuta correttamente");
          },
          error => {
            this.showError("Errore durante la procedura di conferma della distinta");
            return false;
          }
        );
    }
  }

  /* ELIMINAZIONE DI UN DISTINTA */
  eliminaDistinta() {
    //elimino la distinta ed esco

    this._distintaService.eliminaDistinta(this.distintaCorrente).subscribe(
      data => {
        this.showInfo("Eliminazione avvenuta correttamente");
        this.router.navigateByUrl('/distinteincassi');
      },
      error => {
        this.showError("Errore durante la procedura di eliminazione della distinta");
        return false;
      }
    );

  }


  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 2000 });
  }


  /* STAMPA*/
  stampaDistinta() {
    //ritorna il pdf 

    let self = this;

    // Status flag used in the template.
    let pending = true;

    // Create the Xhr request object
    let xhr = new XMLHttpRequest();
    let preurl = this.configuration.apiBaseUrlStampe;
    let MethodPrint = "printDI";
    let url = preurl + MethodPrint + "/" + this.distintaCorrente.token;
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    let scope = this;
    // Xhr callback when we get a result back
    // We are not using arrow function because we need the 'this' context
    xhr.onreadystatechange = function () {

      // We use setTimeout to trigger change detection in Zones
      setTimeout(() => { pending = false; }, 0);

      // If we get an HTTP status OK (200), save the file using fileSaver
      if (xhr.readyState === 4 && xhr.status === 200) {
        let blob = new Blob([this.response], { type: 'application/pdf' });
        //fileSaver.saveAs(blob, 'Report.pdf');
        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob,"distinta incassi "+ scope.distintaCorrente.id+".pdf");
        } else {
          let urlBlob = window.URL.createObjectURL(blob);
          window.open(urlBlob);
        }
      }
    };

    // Start the Ajax request
    xhr.send();
  }  /* APERTURA DETTAGLI */

  openDistintaContanti(incassoCorrente: IncassoModel) {
    let dlgRef = this.distintaContantiDlg.open(DistintaContantiDialog,
      { data: new DistintaContantiDialogConfigModel(incassoCorrente, false) })
      .afterClosed().subscribe((res: IncassoModel) => {

      });
  }

  openDistintaAssegni(incassoCorrente: IncassoModel) {
    let dlgRef = this.distintaAssegniDlg.open(DistintaAssegniDialog,
      { data: new DistintaAssegniDialogConfigModel(incassoCorrente, false), width: '80%' })
      .afterClosed().subscribe((res: IncassoModel) => {
      });
  }



}
export class PartiteDataSource extends DataSource<any> {
  partite: Observable<PartitaListItemModel[]> = null;

  constructor(private data: PartitaListItemModel[]) {
    super();
  }
  connect(): Observable<PartitaListItemModel[]> {
    this.partite = Observable.of(this.data);
    return this.partite;
  }
  disconnect(): void { }

}

export class AccontiDataSource extends  DataSource<any> {
  acconti: Observable<AccontoModel[]> = null;

  constructor(private data:AccontoModel[]) { 
    super();
  }
  connect():Observable<AccontoModel[]> { 

    this.acconti=Observable.of(this.data);
    return this.acconti;
  }
  disconnect():void { }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/distinteIncassi/distinta-incassi-detail.component.ts